module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAECAYAAACDQW/RAAAAHUlEQVR4AczMMQ0AAADCMDL/nsHEDiqgVEIkf9EAAAD//+/u/NMAAAAGSURBVAMAnyVHwT6cNXMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/minus.png
// module id = jQ+s
// module chunks = 2